namespace TabAurous.Retail {
    export interface POSSalesReceiptRow {
        ReceiptId?: number;
        TransId?: number;
        ModeId?: number;
        LedgerId?: number;
        Code?: string;
        Amount?: number;
        TempAmount?: number;
        RefNo?: string;
        ChequeNo?: number;
        ChequeDate?: string;
        Scheme?: string;
        Total?: number;
        Balance?: number;
        RefTransId?: number;
        RefVoucherType?: number;
        BankId?: number;
        SchemeEnrollmentId?: number;
        Denominations?: POSSalesReceiptDetailsRow[];
    }

    export namespace POSSalesReceiptRow {
        export const idProperty = 'ReceiptId';
        export const nameProperty = 'RefNo';
        export const localTextPrefix = 'Retail.POSSalesReceipt';
        export const deletePermission = 'Retail:POSSales:Delete';
        export const insertPermission = 'Retail:POSSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSSales:Edit';

        export declare const enum Fields {
            ReceiptId = "ReceiptId",
            TransId = "TransId",
            ModeId = "ModeId",
            LedgerId = "LedgerId",
            Code = "Code",
            Amount = "Amount",
            TempAmount = "TempAmount",
            RefNo = "RefNo",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Scheme = "Scheme",
            Total = "Total",
            Balance = "Balance",
            RefTransId = "RefTransId",
            RefVoucherType = "RefVoucherType",
            BankId = "BankId",
            SchemeEnrollmentId = "SchemeEnrollmentId",
            Denominations = "Denominations"
        }
    }
}
